export function handleWeatherError(error: unknown): Error {
  // If it's already an Error instance, return it
  if (error instanceof Error) {
    return error;
  }
  
  // Handle Axios errors
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as any;
    if (axiosError.response?.data?.message) {
      return new Error(`API Error: ${axiosError.response.data.message}`);
    }
    if (axiosError.response?.status) {
      return new Error(`API Error: ${axiosError.response.status}`);
    }
    if (axiosError.message) {
      return new Error(`Request Error: ${axiosError.message}`);
    }
  }
  
  // Handle string errors
  if (typeof error === 'string') {
    return new Error(error);
  }
  
  // Default error message
  return new Error('An unexpected error occurred while fetching weather data');
}